module.exports = "<div class=\"container bs-docs-container\">\n    <div class=\"row\">\n        <slot></slot>\n    </div>\n  </div>";


//////////////////
// WEBPACK FOOTER
// ./~/.npminstall/vue-html-loader/1.2.3/vue-html-loader!./~/.npminstall/vue-loader/7.1.7/vue-loader/lib/selector.js?type=template&index=0!./docs/example/container.vue
// module id = 232
// module chunks = 0